;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.SocialConnections = Marionette.ItemView.extend({
		tagName: 'div',
		initialize: function() {
			this.model            = this.getOption('model');
			this.fb_model         = this.getOption('fb_model');
			this.socialConnect    = this.getOption('socialConnect');
			this.formTemplate     = this.getOption('template');
			this.builder_options  = this.getOption('builderOptions');
			var template          = JST[this.formTemplate+'socialConnections'];
			template              =  _.isFunction(template) ? template : JST.socialConnections;
			this.template         = template;

			this.listenTo(this.fb_model, 'facebook:error', function(error){
				this.showErrors([{text: error.text}])
			});

			this.listenTo(this.fb_model, 'facebook:connect:success', function(){
				this.saveFacebookConnect();
			});

			return  this;
		},
		ui: {
			'facebookConnectSubmit': '#js-facebook-connect',
			'twitterConnectSubmit': '#js-twitter-connect'
		},
		events: {
			'click @ui.facebookConnectSubmit': 'facebookConnect',
			'click @ui.twitterConnectSubmit': 'twitterConnect'
		},
		render: function () {

			this.$el.html(this.template({
				facebook : this.socialConnect.facebook,
				twitter  : this.socialConnect.twitter,
				options  : this.builder_options
			}));

			this.showCurrentTab();
			return this;
		},
		saveFacebookConnect: function(){

			$.when.call(null,this.fb_model.save()).done(_.bind(function(resp){
				if (resp.errors.length) {
					this.showErrors(resp.errors);
				}
				else {
					alert('Your facebook account successfully connected.')
				}
				this.hidePreloader();
			}, this));

		},
		showCurrentTab: function(){
			var _this = this;
			setTimeout(function(){
				$(_this.$el).find('.panel-body').addClass('open-tab');
			}, 10);
		},
		facebookConnect: function(){
			this.showPreloader();
			this.fb_model.initFacebookConnect();
		},
		twitterConnect : function(){
			alert("Twitter Connect currently unavailable")
		}
	});

}(window, APP, Backbone, Marionette, $, _));

